module.exports = __webpack_public_path__ + "img/we.4a393768.jpg";